export const electronicSignaturesBenefits = [
   {
      title: "Garantice la integridad y autenticidad de sus actos jurídicos",
      description:
         "La firma electrónica asegura que el contenido del documento no ha sido alterado y confirma la identidad del firmante, proporcionando una sólida evidencia en caso de contingencias legales.",
      image:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/Garantizar_integridad.png",
   },
   {
      title: "Reduzca costos operativos",
      description:
         "Al eliminar la necesidad de imprimir, escanear o enviar documentos físicamente, se reducen gastos en papel, tinta y servicios de mensajería, contribuyendo además a prácticas más sostenibles.",
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/Reducir_costos.png",
   },
   {
      title: "Acelere sus procesos internos",
      description:
         "La posibilidad de firmar documentos en cuestión de minutos optimiza el flujo de trabajo, permitiendo una respuesta más ágil y eficiente en la toma de decisiones y en la ejecución de contratos.",
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/Acelerar-procesos.png",
   },
   {
      title: "Facilite la formalización de relaciones comerciales",
      description:
         "La simplicidad y rapidez de la firma electrónica mejoran la experiencia del cliente y fortalecen las relaciones comerciales, al permitir cerrar acuerdos de manera efectiva.",
      image:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/Facilitar-relaciones.png",
   },
   {
      title: "Obtenga plena validez legal",
      description:
         "Las firmas electrónicas poseen la misma validez que una firma manuscrita, garantizando certeza jurídica y cumplimiento normativo en todas sus transacciones.",
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/Validez_legal.png",
   },
];
